import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';
import {
  CampaignContributionQuery,
  CampaignContributionsData,
  PaginationInput,
  SortInput,
} from 'modules/iterableGoals/types';

export const fetchCampaignContributionsRequest = (queryData: CampaignContributionQuery) => ({
  type: ActionTypes.FETCH_CAMPAIGN_CONTRIBUTIONS_REQUEST,
  queryData,
});

export const fetchCampaignContributionsResponse = (data: CampaignContributionsData) => ({
  type: ActionTypes.FETCH_CAMPAIGN_CONTRIBUTIONS_RESPONSE,
  payload: data,
});

export const fetchCampaignContributionsError = () => ({
  type: ActionTypes.FETCH_CAMPAIGN_CONTRIBUTIONS_ERROR,
});

export const setCampaignContributionPagination = (pagination: PaginationInput) => ({
  type: ActionTypes.SET_CAMPAIGN_CONTRIBUTION_PAGINATION,
  payload: pagination,
});

export const setCampaignContributionSort = (sort: SortInput) => ({
  type: ActionTypes.SET_CAMPAIGN_CONTRIBUTION_SORT,
  payload: sort,
});
